import React, { useMemo } from "react";

import { SingleSelectInput } from "@performyard/py-components";

import { useReviewTemplates } from "../../../api/hooks";

export type ReviewTemplateSummary = { id: string; name: string };

type TemplateSelectProps = {
	value?: ReviewTemplateSummary;
	onChange: (value: ReviewTemplateSummary | null) => void;
	placeholder?: string;
	isClearable?: boolean;
	disabled?: boolean;
};

const TemplateSelect = ({
	value,
	onChange,
	placeholder = "Select a template",
	isClearable = false,
	disabled = false,
}: TemplateSelectProps) => {
	const { data: templates, isLoading } = useReviewTemplates();

	const selectOptions = useMemo(
		() =>
			(templates ?? []).map((template) => ({
				label: template.name,
				value: { id: template._id, name: template.name },
			})),
		[templates]
	);

	return (
		<SingleSelectInput<ReviewTemplateSummary>
			options={selectOptions}
			value={value}
			onChange={onChange}
			placeholder={isLoading ? "Loading..." : placeholder}
			isClearable={isClearable}
			disabled={disabled || isLoading}
			selectionVariant="combobox"
		/>
	);
};

export default TemplateSelect;
